import styled from 'styled-components';
import {
  mobile_width_percentage,
  tablet_portrait_breakpoint,
  tablet_landscape_breakpoint,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const ThreeImageGridStyles = styled.section`
  margin: 96px auto;
  width: ${mobile_width_percentage}%;
  max-width: ${desktop_container_maxwidth_compact}px;

  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 2.5fr 1fr;
    gap: 32px;
  }
  .large-image {
    grid-column-start: 1;
    grid-column-end: span 2;
    grid-row-start: 1;
    grid-row-end: 1;
    width: 100%;
    min-height: 556px;
    background-image: url(${(props) => props.urlLargeImage});
  }
  .small-image-first {
    grid-column: 1;
    grid-row: 2;
    width: 100%;
    background-image: url(${(props) => props.urlSmallImageFirst});
  }
  .small-image-second {
    grid-column: 2;
    grid-row: 2;
    width: 100%;
    background-image: url(${(props) => props.urlSmallImageSecond});
  }
  .large-image,
  .small-image-first,
  .small-image-second {
    background-position: 50% 0%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media only screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .grid-container {
      grid-template-columns: 1.8fr 1fr;
      grid-template-rows: 1fr 1fr;
    }
    .large-image {
      grid-column-start: 1;
      grid-column-end: 1;
      grid-row-start: 1;
      grid-row-end: span 2;
    }
    .small-image-first {
      grid-column: 2;
      grid-row: 1;
    }
    .small-image-second {
      grid-column: 2;
      grid-row: 2;
    }
  }

  @media only screen and (min-width: ${tablet_landscape_breakpoint}px) {
    .grid-container {
      grid-template-columns: 2.3fr 1fr;
    }
  }
`;
